import {Component, inject, Input, OnInit} from '@angular/core'
import {IMessage, MessageService} from '../../services/message.service'
import {DatePipe} from '@angular/common'
import {
  MatCard,
  MatCardActions,
  MatCardContent,
  MatCardHeader,
  MatCardSubtitle,
  MatCardTitle
} from '@angular/material/card'
import {MatProgressBar} from '@angular/material/progress-bar'
import {RouterLink} from '@angular/router'
import {MatButton} from '@angular/material/button'
import {MatDivider} from '@angular/material/divider'

@Component({
  selector: 'spb-read-message',
  imports: [
    MatCard,
    MatCardHeader,
    DatePipe,
    MatProgressBar,
    MatCardContent,
    MatCardTitle,
    MatCardSubtitle,
    MatCardActions,
    MatButton,
    RouterLink,
    MatDivider
  ],
  templateUrl: './read-message.component.html',
  styleUrl: './read-message.component.scss'
})
export class ReadMessageComponent implements OnInit {

  public message!: IMessage

  private messageId!: string

  private service = inject(MessageService)

  @Input()
  set id(id: string) {
    this.messageId = id
  }

  public ngOnInit(): void {
    this.service.getMessage(this.messageId).subscribe({
      next: message => {
        this.message = message
        this.message.content = message.content
      }
    })
  }
}
